<div class="flex-fill">
    <div class="row">
        <div class="col-lg-16 col-md-18 col-xl-18">
            <h5 class="mb-0">
                Ingepland personeel {{ planning.worknumber ?? planning.afas_project_id }}

                @if (!formsDisabled) {
                    <button
                        (click)="addDefaults()"
                        color="primary"
                        mat-icon-button
                        matTooltip="Voeg standaardpersoneel toe">
                        <i class="fas fa-people-group"></i>
                    </button>
                }
            </h5>
            <table class="table table-hover" [class.table-last-col]="!formsDisabled">
                <tr>
                    <th>Functie</th>
                    <th>Medewerker</th>
                    <th style="width: 115px; min-width: 115px">Van</th>
                    <th style="width: 65px; min-width: 65px">Tot</th>
                    <th>Route</th>
                    <th>Opmerking</th>
                    @if (!formsDisabled) {
                        <th>
                            <button class="delete-button" (click)="deleteAll()" color="warn" mat-icon-button>
                                <mat-icon class="fas fa-trash"></mat-icon>
                            </button>
                        </th>
                    }
                </tr>
                @for (formgroup of form.controls; track formgroup) {
                    <tr [formGroup]="formgroup">
                        <td>
                            {{ formgroup.controls.function.value }}
                        </td>
                        <td>
                            {{ formgroup.controls.employee.value }}
                        </td>
                        <td
                            class="datetime-input"
                            matTooltip="{{ formgroup.controls.conflictText.value }}"
                            (mousedown)="conflictMousedown($event, formgroup, conflictTrigger)">
                            <span [matMenuTriggerFor]="conflictMenu" #conflictTrigger="matMenuTrigger"></span>
                            <mat-menu #conflictMenu="matMenu">
                                @for (conflict of formgroup.errors?.notAvailable; track $index) {
                                    @if (conflict.planningId) {
                                        <button mat-menu-item (click)="openConflict(conflict)">
                                            {{ conflict.text }}
                                        </button>
                                    }
                                }
                            </mat-menu>
                            <app-datetime-input
                                [formControl]="formgroup.controls.begindate"
                                labelDate="start"
                                labelTime="tijd" />
                        </td>
                        <td class="datetime-input">
                            <app-datetime-input
                                [formControl]="formgroup.controls.enddate"
                                [hideDate]="true"
                                labelDate="eind"
                                labelTime="tijd" />
                        </td>
                        <td
                            class="p-1 curpoint text-center"
                            [matTooltip]="formgroup.controls.origin?.value"
                            [matTooltipDisabled]="formsDisabled"
                            (click)="selectAddress(formgroup)"
                            matRipple>
                            <app-address-icon
                                class="me-1 ms-1"
                                [address]="formgroup.controls.origin?.value"
                                [userId]="formgroup.value.user_id"
                                [location]="planning.location"
                                [users]="employees" />
                            -
                            <app-address-icon
                                class="me-1 ms-1"
                                [address]="formgroup.controls.work_begin?.value"
                                [location]="planning.location"
                                [userId]="formgroup.value.user_id"
                                [users]="employees" />
                            @if (formgroup.controls.work_begin?.value !== formgroup.controls.work_end?.value) {
                                <app-address-icon
                                    class="me-1 ms-1"
                                    [address]="formgroup.controls.work_end?.value"
                                    [userId]="formgroup.value.user_id"
                                    [location]="planning.location"
                                    [users]="employees" />
                            }
                            -
                            <app-address-icon
                                class="me-1 ms-1"
                                [address]="formgroup.controls.destination?.value"
                                [userId]="formgroup.value.user_id"
                                [location]="planning.location"
                                [users]="employees" />
                        </td>
                        <td class="text-input">
                            <input
                                class="row-input"
                                [formControl]="formgroup.controls.comment"
                                autocomplete="off"
                                placeholder="Omschrijving" />
                        </td>
                        @if (!formsDisabled) {
                            <td>
                                <button class="delete-button" (click)="delete(formgroup)" color="warn" mat-icon-button>
                                    <mat-icon class="fas fa-trash"></mat-icon>
                                </button>
                            </td>
                        }
                    </tr>
                }
            </table>
        </div>
        <div class="col-lg-8 col-md-6 col-xl-6">
            <h5>Aantal per functie</h5>
            <table class="table">
                <tr>
                    <th>Functie</th>
                    <th>Aantal</th>
                </tr>
                @for (sum of sums; track sum) {
                    <tr>
                        <td class="function-cell">
                            {{ sum.function }}
                            @if (!formsDisabled) {
                                <i
                                    class="fa fa-plus ps-2"
                                    (click)="filterFunction = sum.function; addEmployeeSelect.open()"></i>
                            }
                        </td>
                        <td>
                            {{ sum.amount }}
                            @if (sum.function === 'Verkeersregelaar') {
                                / {{ planningForm?.get('traffic_controllers')?.value }}
                            }
                        </td>
                    </tr>
                }
            </table>

            @if (!formsDisabled) {
                <ng-select
                    #addEmployeeSelect
                    [formControl]="fcEmployee"
                    [clearable]="true"
                    (change)="addEmployee(this.fcEmployee.value)"
                    (blur)="filterFunction = null"
                    appearance="outline"
                    name="employee-filter"
                    placeholder="Medewerker toevoegen"
                    notFoundText="Geen medewerkers gevonden"
                    appendTo="body"
                    tabIndex="-1">
                    @for (employee of filteredEmployees | filter: filterFunction : 'function'; track employee) {
                        <ng-option [value]="employee.id"> {{ employee.name }} ({{ employee.function }}) </ng-option>
                    }
                </ng-select>
            }
        </div>
    </div>
</div>
